import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PROJECT_ROLES, ProjectConfiguration } from '@models/ProjectConfiguration';
import { ProjectRole } from '@models/ProjectConfigurationRow';
import { UserId } from '@models/UserProfile';
import { EditMemberDialogComponent } from '../edit-member-dialog/edit-member-dialog.component';
import { SynchronizerService } from 'src/app/synchronizer.service';

type UserGroup = {
  user_id: FormControl<string>;
  user_role: FormControl<ProjectRole>;
  power_user: FormControl<boolean>;
};

@Component({
  selector: 'app-project-members',
  imports: [
    CommonModule,
    MatCardModule,
    MatSelectModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    FormsModule,
  ],
  templateUrl: './project-members.component.html',
  styleUrl: './../project-settings.component.scss'
})
export class ProjectMembersComponent implements OnInit {
  @Input() project!: ProjectConfiguration;
  @Input() formArray!: FormArray;
  @Input() resetEvent!: EventEmitter<void>;

  constructor(private synchronizerService: SynchronizerService, public dialog: MatDialog, private fb: FormBuilder) { }

  ngOnInit() {
    this.addMemberControls();

    this.resetEvent.subscribe(() => {
      this.addMemberControls();
    });
  }

  private addMemberControls() {
    this.formArray.clear();
    this.project.members.forEach(member => {
      const role = this.project.member(member);
      if (role) {
        const g = this.fb.group<UserGroup>({
          user_id: this.fb.control<string>(member, { nonNullable: true }),
          user_role: this.fb.control<ProjectRole>(role.user_role, { nonNullable: true }),
          power_user: this.fb.control<boolean>(!!role.power_user, { nonNullable: true })
        });
        this.formArray.push(g);
      }
    });
  }

  get userGroups(): FormGroup<UserGroup>[] {
    return this.formArray.controls as FormGroup<UserGroup>[];
  }

  get user_id(): UserId {
    return this.synchronizerService.user$.value?.user_id || "";
  }

  get projectRoles(): ProjectRole[] {
    return PROJECT_ROLES;
  }

  newMember() {
    const dialogRef = this.dialog.open(EditMemberDialogComponent, {
      width: '300px',
      data: { project: this.project }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.project?.setMember(result);
        const g = this.fb.group<UserGroup>({
          user_id: this.fb.control<string>(result.user_id, { nonNullable: true }),
          user_role: this.fb.control<ProjectRole>(result.user_role, { nonNullable: true }),
          power_user: this.fb.control<boolean>(!!result.power_user, { nonNullable: true })
        });
        this.formArray.push(g);
      }
    });
  }

  // setMemberRole(userId: string, role: ProjectRole) {
  //   const current = this.project?.member(userId);
  //   if (current) {
  //     current.user_role = role;
  //     this.project?.setMember(current);
  //   }
  // }

  // setPowerUser(userId: string, powerUser: boolean) {
  //   const current = this.project?.member(userId);
  //   if (current) {
  //     current.power_user = powerUser ? 1 : 0;
  //     this.project?.setMember(current);
  //   }
  // }

}
